import {observer} from "mobx-react"
import React from "react"
import {navbarStore} from "../../store/NavbarStore"
import * as ui from "@kroschke/react-ui"
import {authStore} from "../../store";

type Stages = 'prod' | 'qa' | 'dev' | 'local'
const basePath = process.env.PUBLIC_URL

const stage = process.env.REACT_APP_STAGE as Stages

function getIconImage(stage: Stages, basePath: string) {
    switch (stage) {
        case "qa":
        case "local":
        case "dev":
            return `${basePath}/kroschke_${stage}.png`
    }
    return `${basePath}/kroschke.png`
}

function getWideImage(stage: Stages, basePath: string) {
    switch (stage) {
        case "qa":
        case "local":
        case "dev":
            return `${basePath}/kroschke_wide_${stage}.png`
    }
    return `${basePath}/kroschke_wide.png`
}

const Navbar = observer(function Navbar({expanded}: {expanded: boolean}) {
    const icon = getIconImage(stage, basePath)
    const iconExpanded = getWideImage(stage, basePath)
    const items = authStore.hasRole('FEATURE_PREVIEW') ? navbarStore.items : navbarStore.items.filter(e => !e.preview)
    return <ui.Navbar
        expanded={expanded}
        items={items}
        icon={icon}
        iconExpanded={iconExpanded}
    />
})

export {
    Navbar
}
